import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { useSiteData } from '../contexts/SiteDataContext';

const fallbackItems = [
  { icon: "Award", title: "Peças de Alta Qualidade e Procedência", description: "Peças originais e equivalentes de alto desempenho" },
  { icon: "Users", title: "Suporte Técnico Especializado", description: "Equipe com mais de 15 anos de experiência em hidráulica" },
  { icon: "Zap", title: "Envio R\u00e1pido", description: "Estoque pr\u00f3prio e log\u00edstica \u00e1gil para todo o Brasil e Exterior" },
  { icon: "Target", title: "Aplicação Correta Garantida", description: "Identificação precisa para evitar erros e retrabalho" }
];

const Differentials = () => {
  const { pageContents } = useSiteData();
  const data = pageContents.differentials || {};
  const items = data.metadata?.items || fallbackItems;

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#055509] mb-4">{data.title || 'Por Que Escolher a TerraHydro'}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">{data.subtitle || 'Diferenciais que garantem sua satisfação e o sucesso da sua operação'}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((differential, index) => {
            const IconComponent = LucideIcons[differential.icon] || LucideIcons.CheckCircle;
            return (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#FFB025] bg-white">
                <CardContent className="p-8 text-center">
                  <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-[#055509] to-[#0a7a0f] rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <IconComponent className="text-[#FFB025]" size={36} />
                  </div>
                  <h3 className="text-xl font-bold text-[#055509] mb-3 group-hover:text-[#FFB025] transition-colors">{differential.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{differential.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Differentials;
